<div class="new-screen8">
  <div class="container flex flex-col">
    <h5 class="all-head">Trending Podcasts</h5>
    <div class="flex display-mob max-md:!flex-col md:flex-row md:gap-[20px]">
      <div class="max-md:!flex-[1_1_100%] md:flex-[1_1_50%]">
        <div class="flex max-sm:!flex-col sm:flex-row sm:gap-[20px]">
          @if (podcasts?.length > 0) {
            @for (item of podcasts.slice(0, 2); track item) {
              <div class="max-sm:!flex-[1_1_100%] sm:flex-[1_1_50%]">
                <a class="testvideo" href="{{buildHrefLink(item)}}">
                  <div class="mob-brdr-btm flex flex-col">
                    <div class="mrg-after-imgvid">
                      <img [appImgFallback]="item?.['image_url']" imgContext="thumb" alt="img" style="width:100%" />
                    </div>
                    <ul>
                      <li>
                        <!-- <p class="internal-dr-name">{{audio_list5[currentIndex]['sub_headline']}}</p> -->
                        <p class="internal-updates-head"> {{item['headline'] || ''}}</p>
                      </li>
                    </ul>
                  </div>
                </a>
              </div>
            }
          }
        </div>
      </div>
      <div class="max-md:!flex-[1_1_100%] md:flex-[1_1_50%]">
        <div class="flex max-sm:!flex-col sm:flex-row sm:gap-[20px]">
          <div class="max-sm:!flex-[1_1_100%] sm:flex-[1_1_50%]">
            <ul>
              @if (podcasts?.length > 2) {
                @for (item of podcasts.slice(2, 6); track item) {
                  <a class="testvideo" href="{{buildHrefLink(item)}}">
                    <li class="brdr-btm-red">
                      <!-- <p class="internal-dr-name">{{audio_list5[currentIndex]['sub_headline'] }}</p> -->
                      <p class="internal-updates-head"> {{item['headline'] || ''}}</p>
                    </li>
                  </a>
                }
              }
            </ul>
          </div>
          <div class="max-sm:!flex-[1_1_100%] sm:flex-[1_1_50%]">
            <ul>
              @if (podcasts?.length > 6) {
                @for (item of podcasts.slice(6, 10); track item) {
                  <a class="testvideo" href="{{buildHrefLink(item)}}">
                    <li class="brdr-btm-red">
                      <!-- <p class="internal-dr-name">{{audio_list5[currentIndex]['sub_headline'] }}</p> -->
                      <p class="internal-updates-head"> {{item['headline'] || ''}}</p>
                    </li>
                  </a>
                }
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
    <a class="testvideo" href="/podcast">
      <button mat-flat-button class="view-all-btn">View all</button></a>
    </div>
  </div>